import template from "./timesheet-detail.html";
import controller from "./timesheet-detail.controller";

let timesheetDetailComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
}

export default timesheetDetailComponent;



// WEBPACK FOOTER //
// ./client/pages/review/modals/timesheet-detail/timesheet-detail.component.js